import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Box, Button, FormGroup, FormControlLabel, Checkbox
} from '@material-ui/core';
import { getDayText, getYearMonthDate2 } from '../calendar';

import { presentServiceTime } from './functions';
import {
  ADD_SERVICETIME,
  CLOSE_DLG_SERVICETIME,
  selectDialogStateServiceTime
} from './reducer';

const DEFAULT_DAY_ONLY = true;

const ServiceTimeDialog = () => {

  const dispatch = useDispatch();

  const { open, menu, target, disablePbMenu } = useSelector(selectDialogStateServiceTime);
  const [ serviceTypes, setServiceTypes ] = useState({
    normal: true,
    pb: false
  });
  const [ checkedDayOnly, setCheckedDayOnly ] = useState(DEFAULT_DAY_ONLY);

  const handleEnter = () => {
    // init 
    setServiceTypes({
      normal: true,
      pb: false
    });
    setCheckedDayOnly(DEFAULT_DAY_ONLY);
  }

  const handleChangeServiceTypes = evt => {
    setServiceTypes({
      ...serviceTypes,
      [evt.target.name]: evt.target.checked
    });
  }

  const handleChangeDayOnly = evt => {
    setCheckedDayOnly(evt.target.checked);
  }

  const handleClose = () => {
    dispatch({ type: CLOSE_DLG_SERVICETIME });
  };

  const handleOk = () => {
    dispatch({ type: CLOSE_DLG_SERVICETIME });

    dispatch({
      type: ADD_SERVICETIME,
      payload: {
        date: menu.date,
        serviceTime: menu.serviceTime,
        serviceTypes: Object.keys(serviceTypes).filter(key => serviceTypes[key]),
        target,
        dayOnly: checkedDayOnly,
      }
    });
  }

  return (
    <Dialog
      open={open}
      onEnter={handleEnter}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        id="form-dialog-title"
      >
        {target === 'menu' ? '메인메뉴 추가' : '서비스 타임 추가'}
      </DialogTitle>
      <DialogContent>
        {menu &&
        <Box py="8px">
          요일: {getDayText(menu.date)} <br/>
          일자: {getYearMonthDate2(menu.date)}<br/>
          서비스 타임: {presentServiceTime(menu.serviceTime)}<br/>
        </Box>}
        <Box py="8px">
          <div>
            서비스 타입 선택
          </div>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={serviceTypes.normal}
                  onChange={handleChangeServiceTypes}
                  name="normal"  
                />}
              label="밀박스/뷔페"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={serviceTypes.pb}
                  onChange={handleChangeServiceTypes}
                  name="pb"
                  disabled={disablePbMenu}
                />}
              label="PB브랜드"
            />
          </FormGroup>
        </Box>
        <Box py="8px">
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedDayOnly}
                onChange={handleChangeDayOnly}
              />}
            label="선택한 일자에만 추가"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleOk}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ServiceTimeDialog;